module.exports = __webpack_public_path__ + "static/iconAADesign-245f7ddc2343546c7da3e1f40707efcd.svg";